import { Observable } from 'rxjs';

export class DialogData {
    id: number;
    title: string;
    message: string;
    msgSuffix: string;
    customMessage$: Observable<any>;
    btnOk: string;
    displayBtnOk: boolean;
    btnCancel: string;

    constructor(){
        this.displayBtnOk = true;
    }
}
